export default {"src":"/_next/static/media/ACLS.b35f97c8.svg","height":18,"width":18};